namespace $.$$ {
	export class $shm_hitalama_map_widget_float_customizer extends $.$shm_hitalama_map_widget_float_customizer {

		@ $mol_mem
		title( next?: string ): string {
			return this.widget().Custom()?.remote()?.title( next ) ?? ''
		}
		
		@ $mol_mem
		code_js( next?: string ): string {
			return this.widget().Custom()?.remote()?.Code_js( next )?.text( next ) ?? ''
		}

		@ $mol_mem
		code_view_tree( next?: string ): string {
			return this.widget().Custom()?.remote()?.Code_view_tree( next )?.text( next ) ?? ''
		}

		@ $mol_mem
		code_css( next?: string ): string {
			return this.widget().Custom()?.remote()?.Code_css( next )?.text( next ) ?? ''
		}

		@ $mol_mem
		visible_in_menu( next?: boolean ): boolean {
			return this.widget().Custom()?.remote()?.Visible_in_contextmenu( next )?.val( next ) ?? false
		}

		@ $mol_action
		create_instance() {
			const widget = this.map().widget_add( 'custom', this.Map_page().get_pointer_pos() )
			widget?.Type_custom(null)?.remote( this.widget().Custom()?.remote() )
		}
		
	}
}
